export default "__VITE_ASSET__BrTzXWuL__"